export const PARLAY_ROOM_CODES_SC = ['parl_111', 'parl_110', 'parl_112']
export const PARLAY_ROOM_CODES_GC = ['parl_116', 'parl_117', 'parl_118']
export const PARLAY_ROOM_CODES = [...PARLAY_ROOM_CODES_SC, ...PARLAY_ROOM_CODES_GC]
